import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { FormField } from '@/components/form-field';

/** Haalt de uitnodigings-ID uit een geplakte link of code. */
export function parseInvitationCode(input: string): string | null {
  const value = input.trim();
  const fromUrl = /\/uitnodiging\/([\w-]{16,})\/?$/.exec(value)?.[1];
  if (fromUrl) return fromUrl;
  return /^[\w-]{16,}$/.test(value) ? value : null;
}

export function InvitationCodeDialog(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const code = parseInvitationCode(String(new FormData(event.currentTarget).get('code')));
    if (!code) return setError('Plak de volledige uitnodigingslink die je hebt gekregen.');
    setError(null);
    props.onOpenChange(false);
    void navigate(`/uitnodiging/${code}`);
  }

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Uitnodiging invoeren</DialogTitle>
          <DialogDescription>
            Plak de link die je van je clubbeheerder hebt gekregen.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} noValidate className="grid gap-6">
          <FormField id="invitation-code" label="Uitnodigingslink" error={error}>
            <Input name="code" autoComplete="off" placeholder="https://…/uitnodiging/…" />
          </FormField>
          <DialogFooter>
            <Button type="submit">Bekijk uitnodiging</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
